import { render, staticRenderFns } from "./addCapacity.vue?vue&type=template&id=2b614f46&scoped=true"
import script from "./addCapacity.vue?vue&type=script&lang=js"
export * from "./addCapacity.vue?vue&type=script&lang=js"
import style0 from "./addCapacity.vue?vue&type=style&index=0&id=2b614f46&lang=scss&scoped=true"
import style1 from "./addCapacity.vue?vue&type=style&index=1&id=2b614f46&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b614f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b614f46')) {
      api.createRecord('2b614f46', component.options)
    } else {
      api.reload('2b614f46', component.options)
    }
    module.hot.accept("./addCapacity.vue?vue&type=template&id=2b614f46&scoped=true", function () {
      api.rerender('2b614f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/capacity/addCapacity.vue"
export default component.exports